import React, { useState, useEffect } from "react";
// import { getAllBlogs, getPopularBlogs } from "../Blogapi";
import { getAllBlogs, getPopularBlogs } from "../../components/utility/utility";
import Header from "../../components/blog/Header";
import TrendingCarousel from "../../components/blog/TrendingCarousel";
import Popular from "../../components/blog/Popular";

function Blog() {
  // State to store the blog data
  const [blogs, setBlogs] = useState([]);
  const [popularBlogs, setPopularBlogs] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  // Fetch blogs on component mount
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const blogData = await getAllBlogs();
        // console.log(blogs, "sssssssssssssssss");
        setBlogs(blogData);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching blogs:", err);
        setError("Failed to load blogs. Please try again later.");
        setLoading(false);
      }
    };

    const fetchPopularBlogs = async () => {
      try {
        const blogData = await getPopularBlogs();
        setPopularBlogs(blogData);
        // setLoading(false);
      } catch (err) {
        console.error("Error fetching blogs:", err);
        setPopularBlogs([]);
        // setLoading(false);
      }
    };

    fetchPopularBlogs();

    fetchBlogs();
  }, []);

  useEffect(() => {
    if (window !== undefined) {
      window.scrollTo(0, 0);
    }
  }, []);

  if (loading) {
    return  <div style={{height:'100vh', background:"#fff"}}><div id="loader" class="loader"></div>;</div>
  }

  if (error) {
    return <p style={{ color: "red" }}>{error}</p>;
  }

  return (
    <div>
      <Header />
      <div className="compmainnew">
        <TrendingCarousel blogPosts={blogs} />
        <Popular name="Popular" blogs={popularBlogs} />
      </div>
    </div>
  );
}

export default Blog;